// extracted by mini-css-extract-plugin
export default {"popup__title":"mediaDevicesErrorPopup_popup__title__900C1","popup__img":"mediaDevicesErrorPopup_popup__img__mp6T0","popup__text":"mediaDevicesErrorPopup_popup__text__jQLjx"};